import React from 'react';
import { Search } from 'lucide-react';
import { Tooltip } from 'components/atoms/Base/Logo/Tooltip';
import { useTrackClick } from 'hooks/useTrackClick';

export interface AiHelperSidebarButtonProps {
	collapsed: boolean;
	busy: boolean;
	active?: boolean;
	onClick: () => void;
	fullWidth?: boolean;
}

const AiHelperSidebarButton: React.FC<AiHelperSidebarButtonProps> = ({
	collapsed,
	busy,
	active = false,
	onClick,
	fullWidth = false,
}) => {
	const trackClick = useTrackClick();

	const handleClick = () => {
		onClick();
		trackClick('Finder Clicked', 'finder-sidebar-button');
	};

	const inner = (
		<button
			type="button"
			onClick={handleClick}
			disabled={busy}
			className={`group relative flex items-center transition-all duration-200 ease-[cubic-bezier(0.4,0,0.2,1)] text-ui disabled:opacity-50 disabled:pointer-events-none ${
				active
					? 'bg-secondary-background text-primary shadow-[inset_0_0_0_0.2px_theme(colors.tertiary-background)]'
					: 'text-primary-text hover:bg-tertiary-background'
			} ${
				collapsed
					? 'w-9 h-9 rounded-[40px] justify-center'
					: fullWidth
						? 'w-full h-9 px-2 rounded-[40px] justify-start'
						: 'w-[206px] h-9 px-2 rounded-[40px] justify-start'
			}`}
		>
			<div className="w-6 h-6 flex items-center justify-center shrink-0">
				<span className={`transition-colors duration-500 ${active ? 'text-primary' : 'text-primary-text'}`}>
					<Search className="w-[22px] h-[22px]" strokeWidth={1.75} />
				</span>
			</div>
			{!collapsed && (
				<div className="overflow-hidden whitespace-nowrap max-w-[160px] opacity-100 ml-[10px]">
					<span className="text-ui">Finder</span>
				</div>
			)}
		</button>
	);

	if (collapsed) {
		return (
			<Tooltip text="Finder" position="right">
				{inner}
			</Tooltip>
		);
	}

	return inner;
};

export default AiHelperSidebarButton;
